<div [ngClass]="{'linear': linear}" class="banner-area-component">
  <div class="banner_container">
    <div class="banner_content">
      <h1 class="slide-from-left-fade">
        <em [innerHTML]="title"></em>
      </h1>
      <p class="slide-from-left-fade">
        {{description}}
      </p>

      <a [href]="url" class="btn btn-big btn-primary slide-from-left-fade"
        >{{cta}}</a
      >
    </div>

    <div class="lottie__banner__wrapper"></div>
  </div>

  <img class="img-banner" [src]="'assets/img/banners/' + img" alt="" />
</div>
